import { useQuery } from '../../../react-query';
import { riskLimitsApi } from '../../../services/api';

/**
 * Daily LMV / SMV and VaR 95% / 99% history, firmwide and per strategy type,
 * for the Strategy Risk Analytics dialog. Only fetched while the dialog is open.
 * Returns { series: { FIRMWIDE|<strategy type>: [{ date, lmv, smv, var_95, var_99 }] }, var_available }.
 */
export function useRiskHistory(startDate, endDate, enabled = true) {
  return useQuery(
    ['firmwideSummary', 'risk-history', startDate, endDate],
    () => riskLimitsApi.getRiskHistory({ start_date: startDate, end_date: endDate }),
    {
      enabled: Boolean(enabled && startDate && endDate),
      staleTime: 5 * 60 * 1000,
      refetchOnWindowFocus: false,
      retry: false,
    },
  );
}
